import { RootState } from "@/store/store";
import { DimensionSharedCost } from "@/services/cloudchipr.api";
import { dimensionSharedCostsRequestSelector } from "@/store/dimensions/selectors/shared-costs/dimensionSharedCostsRequestSelector";

export const dimensionSharedCostsDataSelector = (
  state: RootState,
): DimensionSharedCost[] => {
  return dimensionSharedCostsRequestSelector(state)?.data ?? [];
};
